import { ReactNode } from 'react';
import { createTheme, ThemeProvider } from '@mui/material';

export const primaryColourMain = '#2A3FF4';
export const primaryColourText = '#0E1029';
export const secondaryColourMain = '#FC641F';
export const errorColourMain = '#F12948';
export const successColourMain = '#2bcf66';

const theme = createTheme({
    typography: {
        fontFamily: 'inherit',
    },
});

// TODO: get rid of this at some point when MUI is gone
export function MUIOverride({ children }: { children: ReactNode }) {
    return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
